import script from "./LineMessageTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./LineMessageTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./LineMessageTemplate.vue?vue&type=style&index=0&id=a2714a70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2714a70"]])

export default __exports__